import axios from 'axios';
import { apiUrl } from './apiUrl';

export const getClientDiscounts = () =>
    axios.get(`${apiUrl}/clientDiscounts`)


// WEBPACK FOOTER //
// ./src/services/smartparking-api/Discounts.js